import React from "react";
import { RightsContext } from "./RightsContext";

export function withRights(Component) {
  let comp = function RightsComponent(props) {
    return <RightsContext.Consumer>{rights => <Component {...props} rights={rights} />}</RightsContext.Consumer>;
  };
  comp.displayName = `withRights(${getDisplayName(Component)})`;
  return comp;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}
